import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import Button from '~components/Button/Button';
import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

interface IProps {
    stateName?: string | undefined;
    planYear?: string | undefined;
    zipFormHeading?: string | undefined;
    zipFormMainCtaCopy?: string | undefined;
    zipFormSecondaryCtaCopy?: string | undefined;
    zipFormQaValue?: string;
    pageFilter?: string;
}

const ZipWithStepperVerticalLegacy = ({
    stateName = 'your state',
    planYear = '',
    zipFormHeading = '',
    zipFormMainCtaCopy = '',
    zipFormSecondaryCtaCopy = '',
    zipFormQaValue = '',
    pageFilter,
}: PropsWithChildren<IProps>) => {
    const heading = zipFormHeading || `See ${planYear} Medicare Advantage plans in ${stateName}`;
    return (
        <div className="pb-2 md:pb-6 lg:pb-10 lg:px-4">
            <section className={classNames('hero-paid-search-legacy-style-vertical-layout')}>
                <h2>{heading}</h2>

                <div className="rounded-lg flex justify-center">
                    <div className="max-w-screen-xs md:max-w-screen-sm lg:max-w-screen-md w-full">
                        <div className="">
                            {/* No value option. Temporary using `zipFormMainCtaCopy` parameter to determine form confiruration for A/B test. TODO: remove after the test is done  */}
                            {zipFormMainCtaCopy === '' && (
                                <ZipForm
                                    buttonTitle="Help me find a plan"
                                    buttonTitleMobile="Help me choose"
                                    buttonWaLink="Hero Guided Flow: help me find a plan"
                                    qaValue={`HeroStepper${zipFormQaValue && `-${zipFormQaValue}`}`}
                                    opts={{
                                        btnStyle: 'primary',
                                        useWideLayout: true,
                                    }}
                                    redirect={{
                                        toUrl: process.env.GATSBY_EHIM_STEPPER_URL,
                                        delay: 500,
                                    }}
                                />
                            )}
                            {/* Value provided option. Temporary using `zipFormMainCtaCopy` parameter to determine form confiruration for A/B test. TODO: remove after the test is done  */}
                            {zipFormMainCtaCopy !== '' && (
                                <ZipForm
                                    buttonTitle="See plans in my area"
                                    buttonTitleMobile="See plans in my area"
                                    buttonWaLink="Hero Guided Flow: see plans in my area"
                                    qaValue={`HeroStepper${zipFormQaValue && `-${zipFormQaValue}`}`}
                                    opts={{
                                        btnStyle: 'primary',
                                        useWideLayout: true,
                                    }}
                                    redirect={{
                                        toUrl: process.env.GATSBY_EHMP_URL,
                                        delay: 500,
                                    }}
                                />
                            )}
                        </div>

                        <div className="mt-6 md:mt-0">
                            <div className="grid grid-cols-12">
                                <div className="col-span-12 md:col-span-12 lg:col-span-6 lg:col-start-4">
                                    {/* No value option. Temporary using `zipFormMainCtaCopy` parameter to determine form confiruration for A/B test. TODO: remove after the test is done  */}
                                    {zipFormMainCtaCopy === '' && (
                                        <Button
                                            islink
                                            forceATag
                                            href={process.env.GATSBY_EHMP_URL}
                                            data-wa-link="Hero Stepper: compare plan"
                                            styletype="secondary"
                                            data-filter={pageFilter}
                                        >
                                            See plans in my area
                                        </Button>
                                    )}
                                    {/* Value provided option. Temporary using `zipFormMainCtaCopy` parameter to determine form confiruration for A/B test. TODO: remove after the test is done  */}
                                    {zipFormMainCtaCopy !== '' && (
                                        <Button
                                            islink
                                            forceATag
                                            href={process.env.GATSBY_EHIM_STEPPER_URL}
                                            data-wa-link="Hero Stepper: help me choose"
                                            styletype="secondary"
                                            data-filter={pageFilter}
                                        >
                                            <span className="md:hidden">Help me choose</span>
                                            <span className="hidden md:block">
                                                Help me find a plan
                                            </span>
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ZipWithStepperVerticalLegacy;
